const AUTH_STORAGE_KEYS = [
  'token',
  'user',
  'currentTenant',
  'tenants',
  'permissions',
  'permissionVersion',
  'sessionFingerprint'
]

export function clearAuthClientState(): void {
  AUTH_STORAGE_KEYS.forEach(key => localStorage.removeItem(key))
}

export function hasMustChangePasswordFlag(value: unknown): boolean {
  if (!value || typeof value !== 'object') return false

  const record = value as Record<string, any>
  return record.mustChangePassword === true ||
    record.must_change_password === true ||
    hasMustChangePasswordFlag(record.user)
}
